<template>
  <nuttrema-layout-east-block>
    <nuttrema-layout-west-three-vertical>

      <div slot="top-left" class="top--left__link">
        <a :title="$t('label.back')" @click="onBackEvent">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>

      <div v-if="_has(meta, 'title')" slot="top-center" class="top--center__title">
        <span>{{ $t(_get(meta, 'title')) }}</span>
      </div>

      <div
        v-if="_get(SysAdminInstanceSubscriptionInvoiceDetails, 'data.payment_actions', []).length > 0"
        slot="top-right"
        class="top--right__link"
        style="margin-right: 0.75em">
        <permissions-control-wrapper
           action="label.edit"
          :required-general="$PERMISSIONS_GENERAL.PROCESS_INVOICES"
          :permissions="_get(SysAdminInstanceSubscriptionInvoiceDetails, 'meta.permissions')">
          <edit-lock-button slot="allowed" :edit.sync="edit"></edit-lock-button>
          <edit-lock-button slot="not-allowed" :lock="true"></edit-lock-button>
        </permissions-control-wrapper>
      </div>

      <template slot="center">
        <nuttrema-loader v-if="SysAdminInstanceSubscriptionInvoiceDetails.fetching"></nuttrema-loader>
        <form-instance-invoice-details
           v-else
          :edit.sync="edit"
          :InvoiceDetails="SysAdminInstanceSubscriptionInvoiceDetails"
          @confirmPayment="onConfirmPayment"
          @denyPayment="onDenyPayment"
          @cancelPayment="onCancelPayment"
          @cancel="onCancelEvent">
        </form-instance-invoice-details>
      </template>
    </nuttrema-layout-west-three-vertical>
  </nuttrema-layout-east-block>
</template>

<script>
import { mapActions } from 'vuex';
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutEastBlock from 'components/ui/layout/nuttrema-layout-east-block';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import FormInstanceInvoiceDetails from 'components/pages/professional/shared/instance-subscriptions/details/form-instance-invoice-details';

export default {
  name: 'page-instance-subscription-invoice-details',
  mixins: [
    PageProps,
  ],
  props: {
    instanceID: {
      required: true,
      default: null,
    },
    subscriptionID: {
      required: true,
      default: null,
    },
    invoiceID: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  components: {
    NuttremaLayoutEastBlock,
    NuttremaLayoutWestThreeVertical,
    FormInstanceInvoiceDetails,
  },
  computed: {
    SysAdminInstanceSubscriptionInvoiceDetails() {
      return this.$store.getters.SysAdminInstanceSubscriptionInvoiceDetails(this.invoiceID);
    },
  },
  methods: {
    ...mapActions([
      'SysAdminInstanceSubscriptionInvoiceDetailsSetConfirmPayment',
      'SysAdminInstanceSubscriptionInvoiceDetailsSetDenyPayment',
      'SysAdminInstanceSubscriptionInvoiceDetailsSetCancelPayment',
    ]),
    onConfirmPayment(payload) {
      this.SysAdminInstanceSubscriptionInvoiceDetailsSetConfirmPayment({
        instanceID: this.instanceID,
        subscriptionID: this.subscriptionID,
        invoiceID: this.invoiceID,
        payload,
      }).then(() => {
        this.successNotification({ label: 'label.confirm_payment' });
        this.edit = false;
      }).catch(() => {
        this.errorNotification({ label: 'label.confirm_payment' });
      });
    },
    onDenyPayment() {
      this.SysAdminInstanceSubscriptionInvoiceDetailsSetDenyPayment({
        instanceID: this.instanceID,
        subscriptionID: this.subscriptionID,
        invoiceID: this.invoiceID,
      }).then(() => {
        this.successNotification({ label: 'label.deny_payment' });
      }).catch(() => {
        this.errorNotification({ label: 'label.deny_payment' });
      });
    },
    onCancelPayment() {
      this.SysAdminInstanceSubscriptionInvoiceDetailsSetCancelPayment({
        instanceID: this.instanceID,
        subscriptionID: this.subscriptionID,
        invoiceID: this.invoiceID,
      }).then(() => {
        this.successNotification({ label: 'label.cancel_payment' });
        this.edit = false;
      }).catch(() => {
        this.errorNotification({ label: 'label.cancel_payment' });
      });
    },
  },
  created() {
    this.$store.dispatch('GetSysAdminInstanceSubscriptionInvoiceDetails', { instanceID: this.instanceID, subscriptionID: this.subscriptionID, invoiceID: this.invoiceID });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearSysAdminInstanceSubscriptionInvoiceDetails', { invoiceID: this.invoiceID });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/system-administration/instances/subscriptions/invoice/page-sys-admin-instance-subscription-invoice-details.vue